import { sanitizeParams } from '../../gds-api-client';

import { BookingParam } from '../components/ApiClientsContext';
import { BookingsObject } from './addressComponentHelper';

interface BookingBody extends BookingsObject {
  memberId: string;
  bookingsSource: string;
  category_code: 'CER' | 'REC';
}

/**
 * Helps with booking-api vendor_profile_id bug
 * booking-api distinguishes between empty string and null values
 * this helper function returns the appropriate vendor_profile_id for an existing booking object
 */
export const getVendorProfileId = (vendor_profile_id: string | null | undefined) => {
  if (vendor_profile_id === '') {
    return { vendor_profile_id: '' };
  }

  if (vendor_profile_id === null) {
    return { vendor_profile_id: null };
  }

  if (vendor_profile_id) {
    return { vendor_profile_id };
  }

  return {};
};

export const getBookingBody = ({
  id,
  address_components,
  vendor_name = '',
  vendor_profile_id,
  bookingsSource,
  memberId,
  category_code,
}: BookingBody): BookingParam => {
  const addressComponent = sanitizeParams(address_components);

  const booking: BookingParam = {
    member_id: memberId,
    category_code,
    source: bookingsSource,
    vendor_name,
    ...getVendorProfileId(vendor_profile_id),
    address_components: (Object.keys(addressComponent).length && addressComponent) || {
      user_entry: {},
    },
  };

  if (id) {
    booking.id = id;
  }

  return booking;
};
